export enum ThemeNames {
  dark = 'dark',
  default = 'default',
  contrast = 'contrast'
}

export type backgroundNames = 'gray';
